<template>
    <div class="btn-right">
        <el-dropdown @command="handleCommand" v-if="exportBtn" v-has="'02010012'" trigger="click">
            <span class="el-dropdown-link">
                导出<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="quoted-tpl-el-dropdown-menu">
                <el-dropdown-item :command="'TEMMPLATE'" :disabled="etLoading"><el-button type="text" :loading="etLoading">导出模板</el-button></el-dropdown-item>
                <el-dropdown-item :command="'DETAIL'" :disabled="edLoading"><el-button type="text" :loading="edLoading">导出明细</el-button></el-dropdown-item>
                <el-dropdown-item :command="'LINE'" :disabled="elLoading"><el-button type="text" :loading="elLoading">导出线路</el-button></el-dropdown-item>
                <el-dropdown-item :command="'ADMINISTRATIVE'" :disabled="eaLoading"><el-button type="text" :loading="eaLoading">导出行政规划</el-button></el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <span v-else class="el-dropdown-link" @click="exportTip" v-has="'02010012'"><i class="el-icon-upload2"></i>导出</span>
        <m-import resourceId='02010013' :disabled="importQuotationBtn?false:true" :num="'2'" :params="uploadParams"
        :uploadUrl="uploadUrl" @import-callback="handleSuccess" :class="importQuotationBtn?'':'export-template'">
            <span slot="button-name">导入报价模板</span>
        </m-import>
        <m-import resourceId='02010014' :disabled="isPrice?false:true" :num="'2'" :params="uploadParams" :uploadUrl="uploadPriceUrl" @import-callback="handleSuccess">
            <span slot="button-name">导入拦标价</span>
        </m-import>
    </div>
</template>
<script>
import { exportLine, exportBidQuoteJSON } from '../../../../api/bidScheme.js';
import { SRM_FILE_PRE } from '../../../../constant/constant.js';
import mImport from '../../../../components/importFile/Import2';

export default {
    name: 'MoreRuleButtons',
    components: { mImport },
    props: {
        exportBtn: {
            type: Boolean,
            default() {
                return false;
            }
        },
        importQuotationBtn: {
            type: Boolean,
            default() {
                return false;
            }
        },
        uploadParams: {
            type: Object,
            default() {
                return {};
            }
        },
        isPrice: {
            type: Boolean,
            default() {
                return true;
            }
        },
        bidData: {
            type: Object,
            default() {
                return {};
            }
        },
        dictData: {
            type: Object,
            default() {
                return {};
            }
        },
        templateCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            exporDetailtURl: `${SRM_FILE_PRE}/bid/exportBidQuoteMoreRuleTemplateData`, // 导出明细
            exportTemplateURl: `${SRM_FILE_PRE}/bid/exportBidQuoteMoreRuleTemplateHeader`, // 导出模板
            uploadUrl: `${SRM_FILE_PRE}/bid/importBidQuoteMoreRuleTemplate`, // 导入报价模板
            uploadPriceUrl: `${SRM_FILE_PRE}/bid/importMoreRuleQuoteRange`, // 导入拦标价
            etLoading: false,
            edLoading: false,
            elLoading: false,
            eaLoading: false
        };
    },
    methods: {
        handleCommand(command) { /** 导出 **/
            const operateObj = {
                LINE: { loading: 'elLoading' },
                ADMINISTRATIVE: { loading: 'eaLoading' },
                TEMMPLATE: {
                    fileName: this.bidData.bidName + '-报价模板.xlsx',
                    url: this.exportTemplateURl,
                    loading: 'etLoading'
                },
                DETAIL: {
                    fileName: this.bidData.bidName + '-报价详情.xlsx',
                    url: this.exporDetailtURl,
                    loading: 'edLoading'
                }
            };
            // 线路 or 行政区域
            if (command === 'LINE' || command === 'ADMINISTRATIVE') {
                const key = command === 'LINE' ? 'REPORT_LCP_DC_LINE' : 'REPORT_LCP_DC_PLACE';
                this[operateObj[command]['loading']] = true;
                exportLine(this.dictData[key]).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('导出成功！请留意右上角文件中心下载文件！');
                    }
                }).finally(() => { this[operateObj[command]['loading']] = false; });
            } else {
                // let apiUrl = '';
                // if (window.location.origin !== 'http://localhost.midea.com:8080') {
                //     apiUrl = config.apiUrl;
                // }
                // window.location = apiUrl + command + '/' + this.$route.query.bidNo + '/' + this.templateForm.templateCode;
                this[operateObj[command]['loading']] = true;
                exportBidQuoteJSON(operateObj[command].url, this.$route.query.bidNo, this.templateCode).then(res => {
                    if (res && +res.code === 0) {
                        var a = document.createElement('a');
                        a.href = res.data.downUrl;
                        a.download = operateObj[command].fileName;
                        a.click();
                        // document.removeChild(a);
                        this.$message.success('导出成功');
                    }
                }).finally(() => { this[operateObj[command]['loading']] = false; });
            }
        },
        exportTip() { // 没选规则时导出的提示
            this.$message.error('当前不能操作');
        },
        handleSuccess(flag) {
            if (flag) {
                this.$emit('success');
            }
        }
    }
};
</script>